import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useMutation } from '@apollo/react-hooks'
import { Button, Label, Icon, Popup } from 'semantic-ui-react'
import gql from 'graphql-tag'

function LikeButton({ user, post: { id, likeCount, likes}}) {

    const [liked, setLiked] = useState(false)

    useEffect(() => {
        if(user && likes.find(like => like.username === user.username)){
            setLiked(true)
        } else setLiked(false)

    }, [user, likes]);

    const [likePost] = useMutation(LIKE_POST_MUTATION, {
        variables: { postId: id }
    })

    const likeButton = user ? (
        liked ? (
            <Button color='teal' aria-label='Like button'>
                <Icon name='heart'/>
            </Button>
        ) : (
            <Button color='teal' basic aria-label='Like button'>
                <Icon name='heart'/>
            </Button>
        )
    ) : (
        <Button as={Link} to='/login' color='teal' basic aria-label='Like button'>
            <Icon name='heart'/>
        </Button>
    )

    return(
        <Popup content={liked ? 'Unlike post' : 'Like post'} inverted trigger={
            <Button as='div' labelPosition='right' onClick={likePost} aria-label="Like button">
            {likeButton}
                <Label basic color='teal' pointing='left'>
                    {likeCount}
                </Label>
            </Button>
        }/>
    )
}

const LIKE_POST_MUTATION = gql `
    mutation likePost($postId: ID!){
        likePost(postId: $postId){
            id
            likes{
                id username
            }
            likeCount
        }
    }
`

export default LikeButton